module.exports = __webpack_public_path__ + "static/media/4_Museum Tower Kyobashi - Tokyo.6c8affb3.jpg";